import { createFileRoute, redirect } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import Loader from '@/components/common/Loader'
import { isSuperAdmin } from '@/lib/authorization'

const SuperAdminOverviewPage = lazy(() =>
  import(
    '@/features/superadmin/pages/SuperAdminOverviewPage/SuperAdminOverviewPage'
  ).then((m) => ({ default: m.default })),
)

export const Route = createFileRoute('/(app)/superadmin/overview')({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!isSuperAdmin(context.auth.userInfo)) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: SuperAdminOverviewRoute,
})

function SuperAdminOverviewRoute() {
  return (
    <Suspense
      fallback={
        <div className="h-page flex items-center justify-center">
          <Loader size="lg" />
        </div>
      }
    >
      <SuperAdminOverviewPage />
    </Suspense>
  )
}
